import { useState, useEffect } from 'react';

function useAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = () => {
      try {
        const adminStatus = localStorage.getItem('admin');
        // Vérifier si c'est explicitement 'true' (string) ou true (boolean)
        setIsAdmin(adminStatus === 'true' || adminStatus === true);
      } catch (error) {
        console.error('Erreur lors de la vérification du statut admin:', error);
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminStatus();
  }, []);

  return { isAdmin, isLoading };
}

export default useAdmin;